"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.daProjectTypeNode = daProjectTypeNode;
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const questionNames_1 = require("../../questionNames");
const commonNodes_1 = require("../commonNodes");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const teamsProjectTypeNode_1 = require("./teamsProjectTypeNode");
function daProjectTypeNode(parentValue = ProjectTypeOptions_1.ProjectTypeOptions.copilotAgentOptionId) {
    return {
        // project-type = Declarative Agent
        condition: { equals: parentValue },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.copilotExtension.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.copilotExtension.placeholder"),
            type: "singleSelect",
            staticOptions: [CapabilityOptions_1.DACapabilityOptions.declarativeAgent()],
            skipSingleOption: true,
        },
        children: [
            {
                condition: { equals: CapabilityOptions_1.DACapabilityOptions.declarativeAgent().id },
                data: {
                    name: questionNames_1.QuestionNames.WithPlugin,
                    title: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.declarativeCopilot.title"),
                    cliDescription: "Whether to add API plugin for your declarative Copilot.",
                    type: "singleSelect",
                    staticOptions: CapabilityOptions_1.DACapabilityOptions.all(),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.declarativeCopilot.placeholder"),
                    onDidSelection: CapabilityOptions_1.setTemplateNameAndGC,
                },
                children: [
                    {
                        condition: { equals: CapabilityOptions_1.DACapabilityOptions.withPlugin().id },
                        data: {
                            type: "singleSelect",
                            name: questionNames_1.QuestionNames.ActionType,
                            title: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.createApiPlugin.title"),
                            cliDescription: "API plugin type.",
                            placeholder: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.addApiPlugin.placeholder"),
                            staticOptions: [
                                CapabilityOptions_1.ActionStartOptions.newApi(),
                                featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration)
                                    ? CapabilityOptions_1.ActionStartOptions.apiSpecWithSearch()
                                    : CapabilityOptions_1.ActionStartOptions.apiSpec(),
                                ...(featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.DAMetaOS)
                                    ? [CapabilityOptions_1.ActionStartOptions.DAMetaOS()]
                                    : []),
                                ...(featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.MCPForDA)
                                    ? [CapabilityOptions_1.ActionStartOptions.mcp()]
                                    : []),
                            ],
                            default: CapabilityOptions_1.ActionStartOptions.newApi().id,
                            onDidSelection: CapabilityOptions_1.setTemplateName,
                        },
                        children: [
                            {
                                condition: { equals: CapabilityOptions_1.ActionStartOptions.newApi().id },
                                data: {
                                    type: "singleSelect",
                                    name: questionNames_1.QuestionNames.ApiAuth,
                                    title: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.apiMessageExtensionAuth.title"),
                                    cliDescription: "The authentication type for the API.",
                                    placeholder: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.apiMessageExtensionAuth.placeholder"),
                                    staticOptions: [
                                        CapabilityOptions_1.ApiAuthOptions.none(false),
                                        CapabilityOptions_1.ApiAuthOptions.apiKey(),
                                        CapabilityOptions_1.ApiAuthOptions.microsoftEntra(),
                                        CapabilityOptions_1.ApiAuthOptions.oauth(),
                                    ],
                                    default: CapabilityOptions_1.ApiAuthOptions.none().id,
                                    onDidSelection: CapabilityOptions_1.setTemplateName,
                                },
                            },
                            featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration)
                                ? (0, commonNodes_1.apiSpecWithSearchNode)()
                                : (0, commonNodes_1.apiSpecNode)((inputs) => inputs[questionNames_1.QuestionNames.ActionType] === CapabilityOptions_1.ActionStartOptions.apiSpec().id),
                            (0, teamsProjectTypeNode_1.MCPServerTypeNode)(),
                        ],
                    },
                ],
            },
        ],
    };
}
//# sourceMappingURL=daProjectTypeNode.js.map